exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-model-select-container.hidden {\n  display: none;\n}\n.custom-model-select-container .ant-select {\n  width: 100%;\n}\n.custom-model-select-container .ant-select.loading .ant-select-selection-item {\n  display: none;\n}\n", ""]);

// exports
